import type { Price } from '../services/schemas';

export function getActivePrice(priceSet: Price[]): Price | null {
  const today = new Date().toISOString().slice(0, 10);
  return (
    priceSet.find((p) => p.validFrom <= today && (p.validTo === null || p.validTo >= today)) ??
    priceSet[0] ??
    null
  );
}
